import { Pipe, PipeTransform } from '@angular/core';
import { IBookingSearchResultColumn, IBookingSearchResultConfig } from "../../interfaces/IConfigurableTable";

@Pipe({
    name: 'findColumnByKey'
})

export class FindColumnByKeyPipe implements PipeTransform {
    public transform(key: string, config: IBookingSearchResultConfig): IBookingSearchResultColumn {
        return config.columnArray.find((column: IBookingSearchResultColumn): boolean => column.key === key);
    }
}
